module.exports = __webpack_public_path__ + "static/img/img_12.c9c6434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_12.jpg
// module id = 92
// module chunks = 20